import useHasMounted from "hooks/useHasMounted/useHasMounted";
import { OBSERVER_PIXEL_APPLICTION_NAME, OBSERVER_PIXEL_CONTENT_HOST } from "lib/constants";
import React from "react";

export type ObserverPixelProps = {
    uid?: string | null;
};

const ObserverPixel: React.FC<ObserverPixelProps> = ({ uid }) => {
    const hasMounted = useHasMounted();

    if (!hasMounted || !uid) return null;

    const pixelTitle = document.title ?? "Missing page title";
    const pixelPage = window.location.href;
    const pixelReferrer = document.referrer ?? "Missing referrer title";

    const encodedUid = encodeURIComponent(uid);
    const encodedTitle = encodeURIComponent(pixelTitle);
    const encodedApplcation = encodeURIComponent(OBSERVER_PIXEL_APPLICTION_NAME);
    const encodedPixelPage = encodeURIComponent(pixelPage);
    const encodedReferrer = encodeURIComponent(pixelReferrer);
    const encodedContentHost = encodeURIComponent(OBSERVER_PIXEL_CONTENT_HOST);

    const src = `${process.env.NEXT_PUBLIC_OBSERVER_PIXEL_LOCATION}?uid=${encodedUid}&ti=${encodedTitle}&ai=${encodedApplcation}&ui=${encodedPixelPage}&rui=${encodedReferrer}&ch=${encodedContentHost}`;

    const imgProps = {
        "data-categories": "analytics",
        "data-testid": "observer-pixel",
        id: "pixel",
        src,
        style: { width: 1, height: 1 },
    };

    // eslint-disable-next-line @next/next/no-img-element
    return <img alt="" {...imgProps} />;
};

export default ObserverPixel;
